import React, { useEffect, useState } from "react";

import CampaignHeaderCard from "./CampaignHeaderCard";
import CampaignSocialMediaCard from "./CampaignSocialMediaCard";
import { handleApi } from "../../utils/authentication";
import { v4 as uuidv4 } from "uuid";
import LoadingSpinner from "./LoadingSpinner";

const CampaignCard = ({
  campaign,
  setCampaignId,
  setShow,
  userList,
  setProgramDetails,
}) => {
  const [socialMediaInfo, setSocialMediaInfo] = useState([]);
  const [loading, setLoading] = useState(false);

  let members_list = [];
  let user_ids = campaign?.user_ids?.split(",");
  user_ids?.forEach((user_id) => {
    let user_details = userList.find((item) => item?.user_id == user_id);
    if (user_details) {
      members_list.push(user_details);
    }
  });

  const fetchSocialMediaMetrics = async () => {
    setLoading(true);
    try {
      if (campaign?.campaign_id) {
        let formData = new FormData();
        formData.append("campaign_id", parseInt(campaign?.campaign_id));
        let result = await handleApi(
          "list_associated_social_media_campaigns",
          "POST",
          {},
          formData,
        );
        if (result?.success) {
          let associated_campaigns = [];

          // Add campaigns from associated_campaigns
          if (result?.associated_campaigns?.length > 0) {
            result?.associated_campaigns.forEach((campaign) => {
              associated_campaigns.push(campaign);
            });
          }

          // Add campaigns from linkedin_associated_campaigns
          if (result?.linkedin_associated_campaigns?.length > 0) {
            result?.linkedin_associated_campaigns.forEach((campaign) => {
              associated_campaigns.push(campaign);
            });
          }
          // Add campaigns from snapchat_associated_campaigns
          if (result?.snapchat_associated_campaigns?.length > 0) {
            result?.snapchat_associated_campaigns.forEach((campaign) => {
              associated_campaigns.push(campaign);
            });
          }

          // Add campaigns from snapchat_associated_campaigns
          if (result?.spotify_associated_campaigns?.length > 0) {
            result?.spotify_associated_campaigns.forEach((campaign) => {
              associated_campaigns.push(campaign);
            });
          }

          // Add campaigns from facebook_associated_campaigns
          if (result?.facebook_associated_campaigns?.length > 0) {
            result?.facebook_associated_campaigns.forEach((campaign) => {
              associated_campaigns.push(campaign);
            });
          }
          // Set the final list of associated campaigns
          setSocialMediaInfo(associated_campaigns);
        }
      }
      setLoading(false);
    } catch (e) {
      console.log("Failed to fetch list_associated_social_media_campaigns");
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSocialMediaMetrics();
  }, [campaign?.campaign_id]);

  return (
    <div className="border_bottom py-3">
      {/* campaign header card */}
      <CampaignHeaderCard
        setProgramDetails={setProgramDetails}
        campaign_id={campaign?.campaign_id}
        campaign_name={campaign?.campaign_name}
        start_date={campaign?.start_date}
        end_date={campaign?.end_date}
        created_at={campaign?.created_at}
        setCampaignId={setCampaignId}
        setShow={setShow}
        status={campaign?.status ? campaign?.status : ""}
        userList={members_list}
        ads_platform_status={campaign?.ads_platform_status || {}}
      />

      {/* social media accordian */}

      <div className="mx-4">
        {/* <div className="accordion custom-accordion social_media_card" id={"accordionExample"+campaign?.campaign_id}>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="headingOne">
                        <div  className="accordion-button collapsed "  >
                            <div className='d-flex justify-content-between w-100 align-items-center h-100'>
                                <div className={"w-100"} onClick={()=>fetchSocialMediaMetrics(campaign?.campaign_id)} 
                                data-bs-target={"#collapseOne"+campaign?.campaign_id}  type="button" data-bs-toggle="collapse" aria-expanded="true" aria-controls="collapseOne">
                                    Social Media Metrics</div>
                           {showSyncBtn? <button onClick={()=>syncAdsCampaignMetrics(campaign?.campaign_id)} style={{width:"120px"}} className="me-2 btn btn-md rounded-pill btn_white gap-1 d-flex align-items-center justify-content-center">
                                Sync now
                            </button>:null}
                            </div>
                          
                        </div>
                    </h2>
                    
                    <div id={"collapseOne"+campaign?.campaign_id} class="accordion-collapse collapse " aria-labelledby="headingOne" data-bs-parent={"#accordionExample"+campaign?.campaign_id}>
                        <div class="accordion-body">
                       
                        
                           { loading ? (<div className='d-flex justify-content-center p-5'>
                                 <LoadingSpinner />
                                 </div>): socialMediaInfo?.length >0 && socialMediaInfo.map((externalCampaign)=>{
                              
                              return <CampaignSocialMediaCard key={uuidv4()} internalCampaign={campaign} externalCampaign={externalCampaign} fetchSocialMediaMetrics={fetchSocialMediaMetrics}/>

                       }) }
                    
                        {socialMediaInfo?.length ==0 && !loading && <div className='d-flex justify-content-center align-items-center py-5'>
                             
                             <h5 >No Social Media Metrics Found</h5>
                            
                            </div>}
                     
                        </div>
                    </div>
                </div>
            </div> */}
        <SocialMediaAccordion
          key={campaign.campaign_id}
          campaign={campaign}
          fetchSocialMediaMetrics={fetchSocialMediaMetrics}
          loading={loading}
          socialMediaInfo={socialMediaInfo}
        />
      </div>
    </div>
  );
};

export default CampaignCard;

const SocialMediaAccordion = ({
  campaign,
  showSyncBtn,
  fetchSocialMediaMetrics,
  syncAdsCampaignMetrics,
  loading,
  socialMediaInfo,
}) => {
  // State to manage the accordion's open state
  const [isOpen, setIsOpen] = useState(false);

  const handleAccordionToggle = () => {
    setIsOpen(!isOpen);

    // If the accordion is opened, fetch the social media metrics
    if (!isOpen) {
      fetchSocialMediaMetrics(campaign?.campaign_id);
    }
  };

  return (
    <div className="accordion" id={"accordionExample" + campaign?.campaign_id}>
      {/* <div
        className={`d-flex bg_primary rounded-4 ${isOpen ? 'rounded-bottom-0' : ''}`}
        id="headingOne"
      >
        <div
          className={`accordion-button ${isOpen ? '' : 'collapsed'} rounded-4`}
          onClick={handleAccordionToggle}
          type="button"
          aria-expanded={isOpen ? 'true' : 'false'}
          aria-controls={"collapseOne" + campaign?.campaign_id}
        >
          <div className="d-flex justify-content-between w-100 align-items-center h-100">
            <div className="w-100 fw-bold">
              Campaign Analytics
            </div>
          </div>
        </div>
      </div> */}

      {/* <div
        id={"collapseOne" + campaign?.campaign_id}
        className={`accordion-collapse rounded-bottom-4 p-2 collapse ${isOpen ? 'show' : ''}`}
        aria-labelledby="headingOne"
        data-bs-parent={"#accordionExample" + campaign?.campaign_id}
      >
        <div className="accordion-body"> */}
      {/* Show loading spinner or metrics */}
      {loading ? (
        <div className="d-flex justify-content-center p-5">
          <LoadingSpinner />
        </div>
      ) : (
        <div className="d-flex flex-column gap_md">
          {socialMediaInfo?.length > 0 ? (
            socialMediaInfo.map((externalCampaign) => (
              <CampaignSocialMediaCard
                key={uuidv4()}
                internalCampaign={campaign}
                externalCampaign={externalCampaign}
                fetchSocialMediaMetrics={fetchSocialMediaMetrics}
              />
            ))
          ) : (
            <div className="d-flex justify-content-center align-items-center">
              {/* <h5>No Social Media Metrics Found</h5> */}
              <h6 className="text-muted">
                No campaign analytics available for display.
              </h6>
            </div>
          )}
        </div>
      )}
    </div>
    // </div>
  );
};
